import accommodationList from './AccommodationList/de.json';
import chat from './Chat/de.json';
import common from './Common/de.json';
import consent from './Consent/de.json';
import forgotPassword from './ForgotPassword/de.json';
import main from './Main/de.json';
import signIn from './SignIn/de.json';
import signUp from './SignUp/de.json';
import transportList from './TransportList/de.json';

export default {
  accommodationList,
  chat,
  common,
  consent,
  forgotPassword,
  signIn,
  signUp,
  transportList,
  main
};
